export default __webpack_public_path__ + "static/media/loading.1ab33a75.svg";